import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { createHttpApi } from './api.js';
import './styles.css';

const api = createHttpApi();
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App api={api} />
  </StrictMode>,
);
